import backToTop from './back-to-top.vue'
import './style.scss'
export default backToTop



// WEBPACK FOOTER //
// ./src/components/backToTop/index.js